import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/Alert";
import { Link } from "react-router-dom";
import { loadAccounts, loadCreditNotes } from "../../redux/actions/tally";
import ServerPaginationTable from "../../components/ServerPaginationTable";
import SyncStatus from "../../components/SyncStatus";
import { migrateTallyCreditNotesData, migrateCNToTally } from "../../api/index";
import SyncRemarkRender from "../../components/SyncRemarkRender";

const columns = [
  {
    Header: "Voucher ID",
    accessor: "cartNoteId",
  },
  {
    Header: "Voucher Number",
    accessor: "cartNoteSequenceCode",
  },
  {
    Header: "Voucher Date",
    accessor: "noteDate",
  },
  {
    Header: "Deskera ID",
    accessor: "deskeraId",
  },
  {
    Header: "Deskera Sequence Code",
    accessor: "deskeraDocumentSequenceCode",
  },
  {
    Header: "Sync Status",
    accessor: "syncStatus",
    Cell: ({ cell: { row } }) => {
      return (
        <SyncStatus
          status={row.original.syncStatus}
          reason={row.original.reason}
          id={row.original.cartNoteId}
        />
      );
    },
  },
  {
    Header: "Sync Remarks",
    accessor: "reason",
    disableSortBy: true,
    Cell: ({ cell: { row } }) => {
      let value =
        row.original?.syncStatus !== "SUCCESSFUL" && row.original?.reason
          ? row.original?.reason
          : "";
      return <SyncRemarkRender value={value} id={row.original.id.toString()} />;
    },
  },
];

function CreditNoteVoucher() {
  const creditNotesData = useSelector((state) => {
    return state.tally.creditNotes;
  });
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const tallyConfig = useSelector((state) => state.tally.accounts);

  useEffect(() => {
    dispatch(loadAccounts());
    dispatch(loadCreditNotes());
  }, []);

  const data = useMemo(() => creditNotesData.data, [creditNotesData]);

  useEffect(() => {
    setLoading(false);
    if (creditNotesData && creditNotesData?.data?.totalPages) {
      setPageCount(creditNotesData?.data?.totalPages);
    }
  }, [creditNotesData]);

  const refreshData = ({ pageSize, pageIndex, status, sortBy, search }) => {
    setLoading(true);
    dispatch(
      loadCreditNotes(pageSize, pageIndex, status, sortBy, search ?? "")
    );
  };

  return (
    <>
      <div className='p-4'>
        <h3 className='mb-3'>Credit Note Voucher</h3>
        {!tallyConfig.data ||
          (!tallyConfig.data.syncEnable && (
            <Alert type='warning'>
              Your synced Credit Note Vouchers will appear here. Please complete{" "}
              <Link to='/app/tally' className='text-alert-warning'>
                <u>Setup</u>
              </Link>{" "}
              before continuing.
            </Alert>
          ))}
        <ServerPaginationTable
          data={data.content ? data.content : []}
          columns={columns}
          migrate={migrateTallyCreditNotesData}
          syncToTally={migrateCNToTally}
          cart='tally'
          refresh={refreshData}
          tab='Credit Note'
          pageCount={pageCount}
          loading={loading}
          rowId='id'
        />
      </div>
    </>
  );
}

export default CreditNoteVoucher;
